import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import PageMeta from '../../components/pageMeta/PageMeta';
import BlogChapter from '../../components/blogChapterComponent/blogChapter';
import { BLOGS } from '../../common/Blogs';
import './blog.css';

const Blog = () => {
  const { name } = useParams();
  const blog = BLOGS.find((item) => item.name === name);

  if (!blog) {
    return (
      <div className="article-page">
        <PageMeta title="Article not found | TryOuts" description="This TryOuts article could not be found." path={`/blog/${name}`} />
        <Header />
        <main id="main-content" className="route-shell section section--night">
          <div className="container">
            <p className="eyebrow">Article not found</p>
            <h1 className="section-title">This field note has moved.</h1>
            <Link className="button button--primary" to="/blog">Browse insights</Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="article-page">
      <PageMeta title={`${blog.title} | TryOuts`} description={blog.subtitle} path={`/blog/${blog.name}`} />
      <Header />
      <main id="main-content" className="article-main">
        <header className="article-hero section--night">
          <div className="container article-hero__inner">
            <Link className="article-back" to="/blog">← All insights</Link>
            <p className="eyebrow">Field note / agent engineering</p>
            <h1>{blog.title}</h1>
            <p className="article-hero__intro">{blog.subtitle}</p>
            <div className="article-byline">
              <span>By {blog.author}</span>
              <span>{blog.date}</span>
              <span>{blog.readTime} read</span>
            </div>
          </div>
        </header>

        <div className="article-layout container">
          <article className="article-content">
            {blog.blogChapters.map((chapter) => <BlogChapter key={chapter.id} {...chapter} />)}
            <div className="article-end">
              <span>End note</span>
              <h2>Have a workflow this could help?</h2>
              <p>We can help you narrow the system, test the risky assumptions, and map a production path.</p>
              <Link className="button button--dark" to="/contact">Plan an agent build ↗</Link>
            </div>
          </article>

          <aside className="article-toc" aria-label="Table of contents">
            <span>On this page</span>
            <nav>
              {blog.blogChapters.map((chapter, index) => (
                <a key={chapter.id} href={`#${chapter.id}`}><i>{String(index + 1).padStart(2, '0')}</i>{chapter.title}</a>
              ))}
            </nav>
          </aside>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
